export default __webpack_public_path__ + "resources/icons/n220-fd0c.webp";